<template>
    <component :is="swiperize ? swiper : 'div'" @scrolled="scrolled">
        <slot />
    </component>
</template>

<script>
    import Swiper from './Swiper.vue';

    export default {
        components: {
            Swiper,
        },

        props: {
            swiperize: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            swiper() {
                return Swiper;
            },
        },

        methods: {
            scrolled() {
                this.$emit('scrolled');
            },
        },
    };
</script>
